import React, { Component, PropTypes } from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';

import Icon from '../components/Icon';

const DragHandle = SortableHandle(() => <Icon id="drag_handle"/>);

const itemShape = {
  key: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  sequence: PropTypes.number.isRequired
};

const itemActions = {
  onInsert: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired
}

class Item extends Component {
  static propTypes = {
    item: PropTypes.shape(itemShape).isRequired,
    twoClickSelect: PropTypes.bool.isRequired,
    ...itemActions
  }

  constructor() {
    super()

    this.state = { clicked: false }
  }

  componentWillUnmount() {
    clearTimeout(this.clickTimeout)
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.twoClickSelect) {
      this.setState({ clicked: false })
    }
  }

  handleClick = event => {
    if (this.props.twoClickSelect) {
      if (this.state.clicked) {
        this.props.onSelect(this.props.item)
        this.setState({ clicked: false })
      } else {
        this.setState({ clicked: true })
        this.clickTimeout = setTimeout(() => this.setState({ clicked: false }), 1000)
      }
    } else {
      this.props.onSelect(this.props.item)
    }
  }

  render() {
    const { item, twoClickSelect, onInsert, onRemove, onEdit } = this.props;

    const itemSelectedClass = item.selected ? 'Item-selected' : ''
    const itemPendingSelectClass = twoClickSelect && this.state.clicked ? 'Item-pending-select' : ''
    const itemClass = `Item ${itemSelectedClass} ${itemPendingSelectClass}`

    return (
      <li className={itemClass}>
        <span className="Item-text" onClick={this.handleClick}>{item.name}</span>
        <input className="Item-input" type="text" autoCapitalize="none" value={item.name} onChange={event => onEdit(item, event.target.value)} />
        <div className="Item-actions">
          <Icon id="circle-plus" onClick={() => onInsert(item)} />
          <Icon id="circle-cross" onClick={() => onRemove(item)} />
          <DragHandle />
        </div>
      </li>
    );
  }
}

export default SortableElement(Item);
export { itemShape, itemActions };



/** WEBPACK FOOTER **
 ** ./src/components/Item.js
 **/